export const queuesPermission = {
    sqsQueuesView: "sqs-queues.get",
};
